function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgLogoDingding(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "uc-svg": "uc-social"
  }, props), React.createElement("path", {
    d: "M19.821 9.493c-.061.212-.142.42-.24.617v.028c-.7 1.494-2.52 4.428-2.52 4.428l-.532.908h2.566L14.176 22l1.113-4.442h-2.021l.7-2.938c-.568.136-1.24.327-2.035.581 0 0-1.077.632-3.098-1.212 0 0-1.362-1.204-.572-1.503a23.38 23.38 0 012.652-.427c1.363-.186 2.226-.286 2.226-.286s-4.251.063-5.26-.096c-1.007-.159-2.27-1.844-2.56-3.324 0 0-.423-.813.908-.427 1.33.386 6.812 1.499 6.812 1.499S5.893 7.23 5.42 6.7c-.473-.532-1.386-2.934-1.268-4.396a.322.322 0 01.427-.286s5.282 2.416 8.897 3.742 6.753 2.016 6.344 3.733z"
  }));
}

SvgLogoDingding.clsName = 'icon-uc-social__logo-dingding';
SvgLogoDingding.remarkName = 'unknown';
export default SvgLogoDingding;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/uc-social/svgr/LogoDingding.js
// module id = 2236
// module chunks = 17 18